// @flow

export const APPLICATION_STATUSES = {
  NEW: /* Status */ getText('New Application'),
  YES: /* Status */ getText('Move Forward'),
  MAYBE: /* Status */ getText('Under Consideration'),
  NO: /* Status */ getText('Screen Out')
};

export const ATS_LINK_WARNINGS = {
  EMAIL: getText(
    `Did you mean to include an email address? Idealist won’t be able to track applicants who email you directly.`
  ),
  URL: getText(
    `Did you mean to include a URL? Idealist won’t be able to track applicants who apply off-site.`
  ),
  BOTH: getText(
    `Did you mean to include an email address or URL? Idealist won’t be able to track applicants who email you directly or apply off-site.`
  )
};
